import { LookupKeys, longMaxAge } from '~/constants';
import { useSessionId } from '~/composables';
import { useKookies } from 'x1-base/composables';

const { orgIdSessionKey } = LookupKeys;

export default defineNuxtRouteMiddleware((to, from) => {
    const { getKookie, setKookie } = useKookies();
    const { getOrGenSessionId } = useSessionId();


    if (import.meta.server) {
        const nuxtApp = useNuxtApp();
        const {
            userObj,
            currentMembershipUid
        } = nuxtApp.$user;
        const current = getKookie(orgIdSessionKey);

        if (userObj.value) {
            const uid = currentMembershipUid.value ?? null;

            if (uid && current !== uid) {
                setKookie(orgIdSessionKey, uid, { maxAge: longMaxAge });
            }
        }
    }

    if (import.meta.client) {
        getOrGenSessionId();
    }
});
